function ModuleLoader(srcArr = []) {
	const instance = srcArr.slice();

	instance.__origPush__ = instance.push;
	instance.push = function(...mods) {
		this.__origPush__.apply(this, mods);

		mods.forEach((mod) => {
			window.advert.pubsub.publish('module.load', mod);
		});
	};

	srcArr.forEach((mod) => {
		window.advert.pubsub.publish('module.load', mod);
	});

	return instance;
}

module.exports = ModuleLoader;
